<div class="row cem-block" style="margin-top: 35px;">
  <div class="col-md-12">
    <div class="cem-title">VALIDACIÓN DEL ÁREA DE COBERTURA CEM</div>
    <div class="program-name">
      Verifica si el programa CEM seleccionado cuenta con cobertura en la ubicación del usuario.
    </div>
  </div>

  <div class="col-md-3 mt-3">
    <mat-label class="cem-label">Tipo de Vía</mat-label>
    <mat-form-field appearance="outline" class="cem-field w-100">
      <mat-select [(ngModel)]="tipoVia" name="tipoVia">
        <mat-option [value]="''" *ngIf="!tipoVia">Seleccionar</mat-option>
        <mat-option *ngFor="let tv of tipoVias" [value]="tv.tipo_via">
          {{ tv.tipo_via }} - {{ tv.nombre_tipo_via }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-md-3 mt-3">
    <mat-label class="cem-label">Número</mat-label>
    <mat-form-field appearance="outline" class="cem-field w-100">
      <input
        matInput
        [(ngModel)]="numeroVia"
        name="numeroVia"
        placeholder="123"
        maxlength="10"
        inputmode="text"
        pattern="[A-Za-z0-9 ]*"
        (keydown)="onKeyDownAlfanumerico($event, true)"
        (input)="onNumeroViaInput($any($event.target).value)"
        (paste)="onPasteNumeroVia($event)">
    </mat-form-field>
  </div>

  <div class="col-md-3 mt-3">
    <mat-label class="cem-label">Número de Placa</mat-label>
    <mat-form-field appearance="outline" class="cem-field w-100">
      <input
        matInput
        [(ngModel)]="numeroPlaca1"
        name="numeroPlaca1"
        placeholder="123"
        maxlength="5"
        inputmode="text"
        pattern="[A-Za-z0-9]*"
        (keydown)="onKeyDownAlfanumerico($event, true)"
        (input)="onNumeroPlaca1Input($any($event.target).value)"
        (paste)="onPasteNumeroPlaca($event)">
    </mat-form-field>
  </div>

  <div class="col-md-3 mt-3">
    <mat-label class="cem-label">&nbsp;</mat-label>
    <div class="cem-placa-wrapper">
      <span class="cem-dash">-</span>
      <mat-form-field appearance="outline" class="cem-field w-100">
        <input
          matInput
          [(ngModel)]="numeroPlaca2"
          name="numeroPlaca2"
          placeholder="123"
          maxlength="5"
          inputmode="text"
          pattern="[A-Za-z0-9]*"
          (keydown)="onKeyDownAlfanumerico($event, true)"
          (input)="onNumeroPlaca2Input($any($event.target).value)"
          (paste)="onPasteNumeroPlaca($event)">
      </mat-form-field>
    </div>
  </div>

  <div class="col-md-6 mt-3">
    <mat-label class="cem-label">Municipio</mat-label>
    <mat-form-field appearance="outline" class="cem-field w-100">
      <mat-select [(ngModel)]="municipio" name="municipio">
        <mat-option *ngFor="let ciudad of ciudades" [value]="ciudad.codigo">
          {{ ciudad.municipio }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="col-md-6 mt-4 d-flex" style="align-items: center;">
    <button type="button" class="btn-linea-negocio btn-linea-seleccionada cem-btn-validate" (click)="validarCobertura()">VALIDAR COBERTURA</button>
  </div>
<!--
  <div class="col-md-12 mt-3">
    <div class="cem-map-info-box">
      <mat-icon class="cem-map-info-icon">info</mat-icon>
      <span class="cem-map-info-text">
        Para ver el mapa de coberturas haga <a [href]="cemCoberturaUrl" target="_blank"
          rel="noopener noreferrer" class="cem-link">clic aquí</a>
      </span>
    </div>
  </div> -->

  <div class="col-md-12 mt-3" *ngIf="mostrarAlerta">
    <div class="cem-alert">
      <div class="cem-alert-icon">i</div>
      <div class="cem-alert-body">
        <div class="cem-alert-title">
          ¡Este programa no tiene cobertura en la dirección especificada!
        </div>
        <!--
        <div class="cem-alert-text">
          Para ver el mapa de coberturas haga <a [href]="cemCoberturaUrl" target="_blank"
            rel="noopener noreferrer" class="cem-link">clic aquí</a>
        </div>
       -->
      </div>
      <button class="cem-alert-close" (click)="mostrarAlerta = false">×</button>
    </div>
  </div>
</div>
